import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_financials/invoice-roll")({
  beforeLoad: ({ context }) => guardRoute(context.me, "invoice-roll"),
  component: Outlet,
});
